export default __webpack_public_path__ + "static/Ed-4afda75b2ac87650254e129d49f9e10b.png";